import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "@/pages/Home";
import WorksheetFromPdf from "@/pages/WorksheetFromPdf";
import Practice from "@/pages/Practice";
import Print from "@/pages/Print";
import Topics from "@/pages/Topics";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Account from "@/pages/Account";
import GradeKindergarten from "@/pages/GradeKindergarten";
import GradeGrade1 from "@/pages/GradeGrade1";
import GradeGrade2 from "@/pages/GradeGrade2";
import GradeGrade3 from "@/pages/GradeGrade3";
import GradeGrade4 from "@/pages/GradeGrade4";
import GradeGrade5 from "@/pages/GradeGrade5";
import GradeGrade6 from "@/pages/GradeGrade6";
import GradeGrade7 from "@/pages/GradeGrade7";
import GradeGrade8 from "@/pages/GradeGrade8";
import GradeAlgebra1 from "@/pages/GradeAlgebra1";
import GradeGeometry from "@/pages/GradeGeometry";
import GradeAlgebra2 from "@/pages/GradeAlgebra2";
import GradePreCalc from "@/pages/GradePreCalc";
import GradeCalculus from "@/pages/GradeCalculus";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              {/* Retired manual grade+topic picker — redirect indexed/bookmarked URLs to the homepage */}
              <Route path="/generate" element={<Navigate to="/" replace />} />
              <Route path="/worksheet-from-photo" element={<WorksheetFromPdf />} />
              {/* Old URL — keep redirecting so existing links/SEO don't 404 */}
              <Route path="/worksheet-from-pdf" element={<Navigate to="/worksheet-from-photo" replace />} />
              <Route path="/practice/:id" element={<Practice />} />
              <Route path="/print/:id" element={<Print />} />
              <Route path="/topics" element={<Topics />} />
              {/* Retired curriculum browser — redirect indexed/bookmarked URLs to the homepage */}
              <Route path="/curriculum" element={<Navigate to="/" replace />} />
              <Route path="/standard/:code" element={<Navigate to="/" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/account" element={<Account />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/grade/kindergarten" element={<GradeKindergarten />} />
              <Route path="/grade/1" element={<GradeGrade1 />} />
              <Route path="/grade/2" element={<GradeGrade2 />} />
              <Route path="/grade/3" element={<GradeGrade3 />} />
              <Route path="/grade/4" element={<GradeGrade4 />} />
              <Route path="/grade/5" element={<GradeGrade5 />} />
              <Route path="/grade/6" element={<GradeGrade6 />} />
              <Route path="/grade/7" element={<GradeGrade7 />} />
              <Route path="/grade/8" element={<GradeGrade8 />} />
              <Route path="/grade/9" element={<GradeAlgebra1 />} />
              <Route path="/grade/10" element={<GradeGeometry />} />
              <Route path="/grade/11" element={<GradeAlgebra2 />} />
              <Route path="/grade/12" element={<GradePreCalc />} />
              <Route path="/grade/calculus" element={<GradeCalculus />} />
            </Routes>
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
